<template>
  <ModalBlock
    v-model="resetAnalyticsModal"
    :model="resetAnalyticsModal"
    :class="style.modalDeleteDoctor"
  >
    <section>
      <span>Сбросить aналитику?</span>
    </section>
    <button :class="style.modalReset" @click="reset()">Сбросить</button>
  </ModalBlock>
  <div :class="style.setRange">
    <div :class="style.radioList">
      <div v-for="(item, num) in selectRange" :class="style.radioTopPanel">
        <input
          :checked="selectedPeriod == item"
          @click="setRange(item)"
          :id="'radio-' + num"
          type="radio"
          name="header"
        />

        <label v-if="item != 'Свой'" :for="'radio-' + num" v-text="item" />
        <label
          :class="style.calendar"
          ref="calendarWrapper"
          v-else
          :for="'radio-' + num"
        >
          <span
            @click="showCalendar = !showCalendar"
            v-text="getSelectDate()"
          />
          <Calendar @range="setRange($event)" v-if="showCalendar" />
        </label>
      </div>
    </div>
    <span
      :class="style.resetDate"
      v-text="getDateReset(analytics['AБ тест']?.['ПК']?.resetDate)"
    />
    <button :class="style.reset" @click="resetAnalyticsModal = true">
      Сброс aналитики
    </button>
  </div>
  <div :class="style.analyticsQuiz">
    <table>
      <thead>
        <tr>
          <th
            v-text="quiz.name"
            :style="{fontSize: '24px', opacity: '1'}"
            rowspan="2"
          />
          <th :class="style.side" colspan="4">Обычная</th>
          <th :class="style.side" colspan="4">АБ тест</th>
        </tr>
        <tr>
          <template v-for="type in dataType">
            <template v-for="category in dataСategory">
              <th v-text="category" />
              <th :class="category == dataСategory[1] ? style.side : ''" />
            </template>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(question, num) in allQuestions" :key="question">
          <th :class="style.question" v-text="question" />
          <th
            v-for="(value, number) in getDataTable(question, num)"
            v-text="value"
            :class="getClassTh(number, getDataTable(question, num).length)"
          />
          <!-- <th :class="style.percent" v-text="getPercent(data, num)" /> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import style from "./AnalyticsComponent.module.scss";
import {timeZone} from "@/http";
import {API} from "@/api/generated";
import Calendar from "@/elements/calendar/CalendarComponent.vue";
import {defineComponent} from "vue";
import {declensionMounthById} from "@/scripts/general";
import {analytics, analyticsItem, Quiz} from "../../typeQuiz";

export default defineComponent({
  components: {
    Calendar
  },
  data() {
    return {
      style,
      resetAnalyticsModal: false,
      analytics: {} as analytics,
      range: ["", ""],
      selectRange: ["Сегодня", "Вчера", "Неделя", "Месяц", "Свой"],
      showCalendar: false,
      selectedPeriod: "Свой",
      dataType: ["обычная", "AБ тест"] as Array<keyof analytics>,
      dataСategory: ["ПК", "Мобилка"] as Array<keyof analytics["обычная"]>
    };
  },
  mounted() {
    this.setData();
    document.addEventListener("mousedown", this.click);
  },
  beforeUnmount() {
    document.removeEventListener("mousedown", this.click);
  },
  methods: {
    getClassTh(number: number, max: number) {
      let classItem = [];
      const letCategory = this.dataСategory.length;

      if (number + 1 == max || number + 1 == max / letCategory) {
        classItem.push(style.side);
      }
      if (number % 2 == 1) {
        classItem.push(style.dataPercent);
      }
      return classItem.join(" ");
    },
    getDataTable(question: string, num: number): Array<string | number> {
      let arrData = [];
      for (const type of this.dataType) {
        for (const category of this.dataСategory) {
          const analytic = this.analytics[type]?.[category];
          const hasData = analytic && "data" in analytic;

          arrData.push(
            hasData ? this.sumQuestion(analytic.data, question) : "0"
          );

          if (num !== 0) {
            arrData.push(hasData ? `${this.getPercent(analytic, num)}` : "0");
          } else {
            arrData.push(" ");
          }
        }
      }

      return arrData;
    },
    getSelectDate() {
      if (!this.range[0] && !this.range[1]) {
        return "Выберите период";
      }
      function formatDate(date: string) {
        const [month, day] = date.split("-").slice(1);
        return `${day} ${declensionMounthById(month)}`;
      }

      return `${formatDate(this.range[0])} → ${formatDate(this.range[1])}`;
    },
    getPercent(data: analyticsItem, num: number) {
      if (num == 0 || data?.data == undefined) {
        return "";
      }
      const general = num == this.allQuestions.length - 1;
      if (num == this.allQuestions.length - 1) {
        num -= 1;
      }
      const previousQuestion = general
        ? this.allQuestions[0]
        : this.allQuestions[num - 1];
      const currentQuestion = general
        ? this.allQuestions[num - 1]
        : this.allQuestions[num];
      const summPrevious = this.sumQuestion(data.data, previousQuestion);
      const summCurrent = this.sumQuestion(data.data, currentQuestion);
      if (summCurrent == 0 || summPrevious == 0) {
        return "0%";
      }
      return ((summCurrent / summPrevious) * 100).toFixed(2) + "%";
    },
    getDateReset(dateTime: string | undefined) {
      if (!dateTime) {
        return;
      }
      let datePlusZona = new Date(dateTime);
      datePlusZona.setHours(datePlusZona.getHours() + timeZone);
      const [date, time] = datePlusZona.toISOString().split("T");
      const [month, day] = date.split("-").slice(1);
      return `${day} ${declensionMounthById(month)} ${time.substring(0, 5)}`;
    },
    reset() {
      if (!this.resetAnalyticsModal) {
        return;
      }
      API.analyticsReset({body: {quizId: this.quiz._id}}).then(() => {
        this.resetAnalyticsModal = false;
        this.setData();
      });
    },
    click(event: Event) {
      const target = event.target as HTMLElement;
      let refsCalendare = this.$refs.calendarWrapper;
      let arrRef: HTMLElement;
      if (!refsCalendare) {
        return;
      }

      if (Array.isArray(refsCalendare)) {
        arrRef = refsCalendare[0];
      } else {
        arrRef = refsCalendare;
      }

      if (
        this.showCalendar &&
        this.$refs.calendarWrapper &&
        !arrRef.contains(target)
      ) {
        this.showCalendar = false;
      }
    },
    setRange(newRangeData: string | string[]) {
      let newRange: Date[] = [];
      if (newRangeData === "Сегодня") {
        let today = new Date();
        newRange = [today, today];
      } else if (newRangeData === "Вчера") {
        let today = new Date();
        today.setDate(today.getDate() - 1);
        newRange = [today, today];
      } else if (newRangeData === "Неделя") {
        let today = new Date();
        let dayOfWeek = today.getDay();
        if (dayOfWeek === 0) {
          dayOfWeek = 7;
        }
        let monday = new Date(today);
        monday.setDate(today.getDate() - (dayOfWeek - 1));

        newRange = [monday, today];
      } else if (newRangeData === "Месяц") {
        let today = new Date();
        let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        newRange = [firstDay, today];
      } else if (Array.isArray(newRangeData) && newRangeData.length == 2) {
        this.showCalendar = false;
        newRange = newRangeData.map((date) => {
          return new Date(date);
        });
      }
      if (newRange.length == 2) {
        this.range = newRange.map((date) => {
          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");
          return `${y}-${m}-${d}`;
        });
      }
    },
    getNameTable(category: string) {
      if (category === "abTest") {
        return this.quiz.name + " (A/Б тест)";
      } else {
        return this.quiz.name;
      }
    },
    async setData() {
      try {
        this.analytics = await API.getQuizAnalytics({
          query: {id: this.quiz._id}
        });
      } catch (err) {
        throw err;
      }
      this.range = this.getDateRange();
    },
    getDateRange() {
      let allDates = [];

      for (const group of Object.values(this.analytics ?? {})) {
        if (group) {
          for (const data of Object.values(group["ПК"]?.data ?? {})) {
            allDates.push(...Object.keys(data ?? {}));
          }
          for (const data of Object.values(group["Мобилка"]?.data ?? {})) {
            allDates.push(...Object.keys(data ?? {}));
          }
        }
      }

      allDates.sort();

      return [allDates[0], allDates[allDates.length - 1]];
    },
    sumQuestion(groupData: analyticsItem["data"], question: string) {
      let summ = 0;
      if (question === "Общая") {
        question = this.allQuestions[this.allQuestions.length - 2];
      }

      let [minDate, maxDate] = this.range;
      for (const ip in groupData) {
        for (const date in groupData[ip]) {
          if (date >= minDate && date <= maxDate) {
            summ += groupData[ip][date][question] || 0;
          }
        }
      }

      return summ;
    },
    showTable(category: string) {
      if (category === "abTest") {
        return this.quiz.ABTestBool;
      }
      return true;
    }
  },
  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },
    allQuestions(): string[] {
      return [
        "Стартовая страница",
        ...this.quiz.questions.map((q) => q.question),
        "Общая"
      ];
    }
  },
  watch: {
    quiz() {
      this.setData();
    }
  }
});
</script>
